import * as React from "react";
import {
    ApolloError,
    gql,
    useMutation,
} from "@apollo/client";
import {
    CreateOfferPointsDeductionMutationMutation,
    CreateOfferPointsDeductionMutationMutationVariables
} from "../../../../../schemaTypes";
import { NormalizedErrorMap } from "../../../../../types/NormalizedErrorMap";
import { normalizeErrors } from "../../../../../utils/normalizeErrors";

export const createOfferPointsDeductionMutation = gql`
  mutation CreateOfferPointsDeductionMutation(
    $offerId: String!
    $point: Int!
  ) {
    createOfferPointsDeduction(
      offerId: $offerId
      point: $point
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  onMessage?: (message: string) => void;
  children: (
    data: {
      submit: (
        values: CreateOfferPointsDeductionMutationMutationVariables
      ) => Promise<{
        errors: NormalizedErrorMap | null;
        message?: string;
      }>;
      loading: boolean;
      error?: ApolloError;
    }
  ) => React.ReactElement | null;
}

export const CreateOfferPointsDeductionController: React.FC<Props> = ({ children, onMessage }) => {
  const [_createOfferPointsDeductionMutation, { loading, error }] = useMutation<
    CreateOfferPointsDeductionMutationMutation,
    CreateOfferPointsDeductionMutationMutationVariables
  >(createOfferPointsDeductionMutation);

  const submit = async (values: CreateOfferPointsDeductionMutationMutationVariables) => {
    const { data } = await _createOfferPointsDeductionMutation({
      variables: values,
    });

    const errors = data?.createOfferPointsDeduction?.errors
      ? normalizeErrors(data.createOfferPointsDeduction.errors)
      : null;

    if (data?.createOfferPointsDeduction?.message && onMessage) {
      onMessage(data.createOfferPointsDeduction.message);
    }

    return {
      errors,
      message: data?.createOfferPointsDeduction?.message ?? undefined,
    };
  };

  return children({ submit, loading, error });
};
